import office from './Components/Welcome/office.svg'

const Contact = () => {
    return (
        <div className="select-none">
            <div className="max-w-full mx-auto p-6 lg:px-12 lg:py-20 grid grid-cols-1 space-y-12 justify-between items-center text-zinc-800 dark:text-zinc-200">
                <div className="flex flex-col space-y-4">
                    <div className="uppercase text-sm font-extralight text-zinc-500 dark:text-zinc-400">Let's work together</div>
                    <h2 className="text-3xl lg:text-4xl font-light capitalize text-zinc-900 dark:text-white">How can we help?</h2>
                    <div className="border-b border-slate-200 dark:border-slate-800 lg:w-2/12"></div>
                    <div className="font-light text-sm lg:w-8/12 text-zinc-600 dark:text-zinc-400 leading-relaxed">Connect with one of our global teams regarding an upcoming project or transformation need.</div>
                    <div className="text-sm font-light flex flex-col space-y-4 text-zinc-700 dark:text-zinc-300">
                        <div>Email us: <a href="mailto:info@jibulabs.com" className="text-purple-600 dark:text-purple-400 hover:underline">info@jibulabs.com</a></div>
                        <div>Call us: <a href="tel:+18664717185" className="text-purple-600 dark:text-purple-400 hover:underline">+1 (866) 471 7185</a></div>
                    </div>
                </div>
                <div className="">
                    <img src={office} className="rounded-sm shadow-md opacity-90 dark:opacity-100 transition-opacity duration-300" alt="Jibu Labs office"></img>
                </div>
            </div>
        </div>
    )
}

export default Contact